import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core'

import { ShareButton } from '../shared/share-button.class'
import { ShareProvider } from '../shared/share-provider.enum'

@Component({
  selector: 'cm-share-button',
  templateUrl: './share-button.component.html',
  styleUrls: ['./share-button.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShareButtonComponent implements OnInit {

  @Input() url: string
  @Input() image: string

  @Input() button: ShareButton

  @Output() popUpClose = new EventEmitter<ShareProvider>()

  constructor() { }

  ngOnInit() {
  }

  onPopUpClose(provider: ShareProvider) {
    this.popUpClose.emit(provider)
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/social-share/share-button/share-button.component.ts